export const displayFlexAlignItemsCenterJustifyContentCenter = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
export const displayFlexAlignItemsCenterJustifyContentSpaceBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};
export const displayFlexAlignItemsCenterJustifyContentFlexStart = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
};
export const displayFlexAlignItemsCenterJustifyContentFlexEnd = {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
};
export const flexDirection = {
  row: {
    flexDirection: "row",
  },
  column: {
    flexDirection: "column",
  },
};
